import './progress-circle.css';

export function ProgressCircle(props) {
    const value = props.value ? props.value : 0;
    const percent = value / 100;
    const radius = 45;
    const circumference = Math.PI * radius * 2;
    const progress = circumference * percent;

    const className = props.class ? props.class : "";

    return (
        <svg viewBox="0 0 100 100" className={`progress-circle ${className}`}>
            <circle r="45" cx="50" cy="50" strokeDasharray={circumference} className="background-border"></circle>
            <circle r="45" cx="50" cy="50" strokeDasharray={`${progress}, ${circumference}`} className="active-border"></circle>
        </svg>
    );
}